import { render, staticRenderFns } from "./BankEditDefault.vue?vue&type=template&id=1bc889d0&scoped=true"
import script from "./BankEditDefault.vue?vue&type=script&lang=ts"
export * from "./BankEditDefault.vue?vue&type=script&lang=ts"
import style0 from "./BankEditDefault.vue?vue&type=style&index=0&id=1bc889d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc889d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bc889d0')) {
      api.createRecord('1bc889d0', component.options)
    } else {
      api.reload('1bc889d0', component.options)
    }
    module.hot.accept("./BankEditDefault.vue?vue&type=template&id=1bc889d0&scoped=true", function () {
      api.rerender('1bc889d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/BankEditDefault.vue"
export default component.exports